var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1764071283631,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10027,
    "data-spm-anchor-id": "a313x.search_index.0.i6.37843a81i7sRSj",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 455.808C0 199.808 160 0 512 0c384 0 512 236.352 512 455.808 0 219.392-146.304 475.392-512 475.392-73.152 0-133.312 1.792-182.848 18.304-30.4 10.112-57.664 24.128-81.28 36.224-38.656 19.84-67.328 34.56-83.328 18.624-25.664-25.664 0-128 18.304-182.848C121.92 784.96 0 675.2 0 455.808zM512 704c300.352 0 416-73.408 416-272 0-198.592-88.32-288-416-288s-416 89.408-416 288C96 630.592 211.648 704 512 704z",
    "p-id": 10028,
    "data-spm-anchor-id": "a313x.search_index.0.i1.37843a81i7sRSj",
    className: "",
    fill: "#182E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M704 309.312c23.552 0 42.624 19.136 42.624 42.688v128a42.688 42.688 0 1 1-85.312 0v-128c0-23.552 19.136-42.688 42.688-42.688zM296.96 513.728a42.688 42.688 0 0 1-13.12-58.88l80-125.76a42.688 42.688 0 0 1 72.192 0.256l80 128a42.688 42.688 0 1 1-72.32 45.248l-44.16-70.656-43.712 68.672a42.688 42.688 0 0 1-58.88 13.12z",
    "p-id": 10029,
    "data-spm-anchor-id": "a313x.search_index.0.i2.37843a81i7sRSj",
    className: "",
    fill: "#182E4E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiRobot);
export default __webpack_public_path__ + "static/media/AiRobot.2ba0334e.svg";
export { ForwardRef as ReactComponent };